import React, { FC, CSSProperties, useState, FormEvent } from 'react';
import { useAuth } from '../contexts/AuthContext';
import backgroundImage from '../components/background.png';

const LoginPage: FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(username, password);
      // Redirect will be handled automatically by App.tsx when user becomes authenticated
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка авторизации');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}></div>

      {/* Main content */}
      <div style={styles.mainContent}>
        {/* Left side - Company logo */}
        <div style={styles.leftSection}>
        </div>

        {/* Center - Login form */}
        <div style={styles.centerSection}>
          <div style={styles.loginCard}>
            <div style={styles.formTitle}>Вход в систему</div>
            
            <form style={styles.form} onSubmit={handleSubmit}>
              <div style={styles.inputGroup}>
                <input
                  type="text"
                  placeholder="Введите логин"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={styles.input}
                  required
                />
              </div>
              
              <div style={styles.inputGroup}>
                <input
                  type="password"
                  placeholder="Введите пароль"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={styles.input}
                  required
                />
              </div>

              {error && (
                <div style={styles.error}>{error}</div>
              )}

              <button 
                type="submit" 
                style={{
                  ...styles.loginButton,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer'
                }}
                disabled={isLoading}
              >
                {isLoading ? 'Вход...' : 'Войти'}
              </button>
            </form>
          </div>
        </div>

        {/* Right side - empty for balance */}
        <div style={styles.rightSection}></div>
      </div>
    </div>
  );
};

export default LoginPage;

// --- Styles ---

const styles: { [key: string]: CSSProperties } = {
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    zIndex: 10,
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 60px',
    paddingTop: '60px',
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  logoIcon: {
    width: '80px',
    height: '80px',
    background: 'linear-gradient(135deg, #4a9eff, #82caff)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#fff',
    letterSpacing: '2px',
  },
  logoText: {
    display: 'flex',
    flexDirection: 'column',
  },
  companyName: {
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '4px',
    letterSpacing: '2px',
  },
  companySubtitle: {
    fontSize: '14px',
    color: '#ccc',
    fontWeight: '400',
    letterSpacing: '1px',
  },
  centerSection: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightSection: {
    flex: 1,
  },
  loginCard: {
    background: 'rgba(35, 36, 40, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: '40px',
    width: '350px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  formTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff',
    textAlign: 'center',
    marginBottom: '30px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    padding: '14px 16px',
    fontSize: '14px',
    color: '#fff',
    outline: 'none',
    transition: 'all 0.3s ease',
  },
  loginButton: {
    background: '#4472C4',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '14px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '10px',
  },
  error: {
    color: '#ff6b6b',
    fontSize: '12px',
    textAlign: 'center',
    padding: '8px',
    background: 'rgba(255, 107, 107, 0.1)',
    borderRadius: '6px',
    border: '1px solid rgba(255, 107, 107, 0.3)',
  },
};